<template>
  <div>
 <div class="ttp" style="margin-top:10px">
   <el-select size="mini" @change="torz"  v-model="cblx" placeholder="参保类型">
     <el-option
       v-for="item6 in cblxList"
       :key="item6.value"
       :label="item6.label"
       :value="item6.value">
     </el-option>
   </el-select>
 </div>
    <div class="ttp">
      <div class="uploadd">
        <p class="etitle">excel上传</p>
    <el-upload
          style="margin-top: 10px"
          class="upload-demo"
          ref="upload3"
          :action="grantInfoUrl"
          multiple
          drag
          accept=".xlsx"
          :limit="1"
          :headers="myHeader"
          :data="{adrState:this.adrState,verify_type:this.verify_type}"
          :before-upload="handleBeforeUpload"
          :file-list="fileList"
          :on-exceed="handleExceed"
          :on-success="uploadSuccess"
          :on-error="uploadError"
          :auto-upload="false"
          :on-change="handleFileChange"
          :on-remove="handleRemove">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div slot="tip" class="sug">1.上传前请点先下载模板,填写信息再上传,身份证号不能空</div>
          <div slot="tip" class="sug">2.excel行数最好不超过300行,否则处理比较慢</div>
        </el-upload>
        <div class="btn">
         <a href="https://socialsecurity-storage.oss-cn-beijing.aliyuncs.com/停保人员名单.xlsx"><el-button style="margin: 10px" type="success">模板下载</el-button></a>
        <el-button style="margin: 10px"  type="success" @click="submitUpload3">数据导入</el-button>
        </div>
  </div>
  </div>
  </div>
</template>
<script>
  import {baseUrl} from "../../utils/global";
  import {getType} from "../../utils/typeAuth";
  import Cookies from "js-cookie";
  let uploadedList = [];
  export default {
   strReplace(msg){
    let str=getType(msg)
        return str
    },
    name: "importByExcel",
    data() {
      return {
        adrState: 4 ,
        //参保类型
        verify_type:'',
        cblx:"",
        cblxList:[],
        grantInfoUrl: baseUrl + "/excel/deal/adrState",
        myHeader: {
          token: Cookies.get("token")
        },
        fileList: [],
        dialogTitle: "",
        dialogVisible: false,
        dialogContent: "",
        loading: false
      };
    },
    methods: {
      handleFileChange(file, fileList) {
        this.fileList = fileList;
      },
      handleRemove(file, fileList) {
        this.fileList = fileList;
      },
      submitUpload1() {
        this.$refs.upload1.submit();
      },
      submitUpload2() {
        this.$refs.upload2.submit();
      },
      submitUpload3() {
          // 首先判断是否选择了文件
        if (this.fileList.length === 0) {
          this.$message.warning('请先选择要上传的文件');
          return;
        }
        // 添加verify_type判断逻辑
        if (!this.verify_type) {
          this.$confirm('当前未选择参保类型，将默认选择所有类型，是否继续上传？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$refs.upload3.submit();
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消上传'
            });
          });
        } else {
          this.$refs.upload3.submit();
        }
      },
      handleExceed() {
        this.$message.warning("当前限制选择 1 个文件，请删除后继续上传");
      },
      handleBeforeUpload(file) {
        this.loading = true;
        if (!file.name.endsWith(".xlsx")) {
          this.$message.warning(file.name + "不是excel文件");
          this.loading = false;
          return false;
        }
        if (file.size > 2 * 1024 * 1024) {
          this.$message.warning(file.name + "文件大于2MB,无法上传");
          this.loading = false;
          return false;
        }
      },
      async uploadSuccess(response) {
        console.log("类型-"+this.cblx);
        this.adrState=4;
        this.fileList = [];
        this.verify_type=this.cblx;
        
        // 添加对code的判断
        if (response.code === 200) {
          this.dialogTitle = "导入结果";
          this.dialogContent = response.data;
          this.loading = false;
          console.log("upload success");
          this.$message({
            type: "success",
            message: response.message
          });
        } else {
          this.dialogTitle = "导入失败";
          this.dialogContent = response.message;
          this.loading = false;
          console.log("upload failed: " + response.message);
          this.$message({
            type: "error",
            message: response.message
          });
        }
      },
      async uploadError(response) {
      this.adrState=4;
        this.fileList = [];
        this.verify_type=cblx;
        this.dialogTitle = "导入结果";
        this.dialogContent = "导入失败";
        this.loading = false;
        this.$message({
          type: "error",
          message: "系统错误"
        });
      },
      torz(){
        this.verify_type=this.cblx;
      },
      },
      created(){
                let arr;
          if(sessionStorage.getItem("typeControll")=="null"){
             arr=JSON.parse(sessionStorage.getItem("codes"))
          }else{
            arr=JSON.parse(sessionStorage.getItem("typeControll"))

          }

          for(let i in arr){
            this.cblxList.push({
              label:getType(arr[i]),
              value:arr[i]
            })
          }
          this.cblx=arr[0]

              }
    }
</script>
<style scoped>
.ttp{
  display: flex;
  border: 1px dashed lightgray;
  border-top: none;
  border-radius: 5px
}
.etitle{
  font-weight: bolder;
  font-size: 20px;
  text-align: center;
}
.upload-demo{
  text-align: center;
}
.sug{
  color: red;
  font-size: 20px;
}
.uploadd{
  width: 100%;
  padding-left: 20px
}
.btn{
  width: 50%;
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
  margin-top: 15px;
}
.eg img{
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/Myvue/upload4.vue